"use client";
import React, { useEffect } from "react";
import "./Registrieren.css";
// import RegistrierenTop from "./sections/RegistrierenTop";
import RegistrierenMain from "./sections/RegistrierenMain";
import { useAuth } from "@/context/AuthProvider";
import { useRouter } from "next/navigation";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

function Registrieren() {
  const { userData, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!userData || loading) return;

    const companyInformation = userData.companyInformation;
    if (companyInformation && !companyInformation.accessGranted) {
      router.replace("/verifikation");
      return;
    }

    router.replace("/marktplatz");
  }, [userData, loading, router]);

  if (loading) return <LoadingAnimation />;
  return (
    <div className="Registrieren">
      {/* <RegistrierenTop /> */}
      <RegistrierenMain />
    </div>
  );
}

export default Registrieren;
